import md5 from 'md5'
import { ref, child, get } from 'firebase/database'
import { database } from 'services/firebase'
import { RDB_COLLECTIONS } from '__constants__'

const checkIsEmailExist = async (email) => {
  const hashedEmail = md5(email)

  const isEmailExistSnapshot = await get(
    child(ref(database), `${RDB_COLLECTIONS.EMAIL_TO_EXISTENCE}/${hashedEmail}`)
  )
  return isEmailExistSnapshot?.exists() ? isEmailExistSnapshot?.val() : null
}
export default checkIsEmailExist
